
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import type { DragStateUser } from '@/contexts/DragStateContext';

interface ColumnDragTargetProps {
  dragUsers: DragStateUser[];
  columnTitle: string;
}

export function ColumnDragTarget({ dragUsers, columnTitle }: ColumnDragTargetProps) {
  if (dragUsers.length === 0) return null;

  return (
    <div className="absolute inset-0 pointer-events-none z-40">
      {/* Highlight overlay */}
      <div className="absolute inset-0 bg-blue-500/10 dark:bg-blue-400/10 border-2 border-dashed border-blue-500 dark:border-blue-400 rounded-lg animate-pulse" />
      
      {/* Drop zone indicator */}
      <div className="absolute top-2 right-2 flex items-center gap-2">
        <div className="flex -space-x-1">
          {dragUsers.slice(0, 2).map((user) => (
            <Avatar key={user.user_id} className="h-6 w-6 border-2 border-blue-500 shadow">
              <AvatarFallback className="bg-blue-500 text-white text-xs font-bold">
                {(user.user_name ?? "?").slice(0, 2).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ))}
        </div>
        <Badge variant="secondary" className="text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
          Drop here
        </Badge>
      </div>
      
      {/* Drop zone text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 opacity-60">
            Drop Zone
          </div>
          <div className="text-sm text-blue-500 dark:text-blue-300 opacity-80">
            {dragUsers.length === 1 
              ? `${dragUsers[0].user_name} is dropping here`
              : `${dragUsers.length} users dropping here`
            }
          </div>
        </div>
      </div>
    </div>
  );
}
